import { Stack } from '@mui/material';
import { portfolioNameAndDetails } from '../../../utils/portfolioNameAndDetails';
import { AvatarInvertedPortfolio } from '../../XcalaComponents/AvatarInvertedPortfolio';
import { LogoXcala } from '../InternalLayout/LogoXcala';
import HeaderUserInfo from './HeaderUserInfo';
import { ContentWrapper, HeaderBackground } from './StyledComponentHeader';

const HeaderLayout = ({
  fileAs,
  type = 'user',
  dataChart,
  goToProductDetail,
  editableUserHeader = false,
  showLogoOnly = false,
  mode,
  details,
}) => {
  let result = null;

  if (mode === 'portfolio' && dataChart?.name) {
    result = portfolioNameAndDetails(dataChart?.name);
  }

  return (
    <HeaderBackground>
      <ContentWrapper
        justifyContent={fileAs?.profit ? { md: 'space-evenly', xs: 'center' } : 'center'}>
        {showLogoOnly ? (
          <LogoXcala />
        ) : type === 'user' ? (
          <HeaderUserInfo editable={editableUserHeader} />
        ) : type === 'riskSelection' ? (
          <LogoXcala />
        ) : (
          <Stack
            sx={{
              width: '100%',
            }}
            justifyContent={'center'}
            alignItems={'center'}>
            {mode === 'portfolio' ? (
              <AvatarInvertedPortfolio
                porfolioDetailHeader={result}
                goToProductDetail={goToProductDetail}
                details={details}
              />
            ) : (
              <AvatarInvertedPortfolio
                porfolioDetailHeader={fileAs}
                goToProductDetail={goToProductDetail}
                details={details}
              />
            )}
          </Stack>
        )}
      </ContentWrapper>
    </HeaderBackground>
  );
};

export default HeaderLayout;
